import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { ListeComponent } from "../liste/liste.component";
import { GeneralService } from "../services/general.service";

@Component({
  selector: "app-blogues",
  templateUrl: "./blogues.component.html",
  styleUrls: ["./blogues.component.scss"],
})
export class BloguesComponent implements OnInit {
  constructor(
    public generaleService: GeneralService,
    public dialog: MatDialog
  ) { }
  dsBlogues;
  blogue;
  blogue_TitreEn: string;
  blogue_TitreFr: string;
  blogue_P1Fr: string = "";
  blogue_P1En: string = "";
  blogue_P2Fr: string = "";
  blogue_P2En: string = "";
  blogue_P3Fr: string = "";
  blogue_P3En: string = "";

  blogue_T1Fr: string = "";
  blogue_T1En: string = "";
  blogue_T2Fr: string = "";
  blogue_T2En: string = "";
  blogue_T3Fr: string = "";
  blogue_T3En: string = "";
  editorConfig: AngularEditorConfig = JSON.parse(
    JSON.stringify(this.generaleService.editorConfig)
  );
  editorConfig2: AngularEditorConfig = JSON.parse(
    JSON.stringify(this.generaleService.editorConfig)
  );
  listeLanges = [];
  listeType = [
    { value: "GUIDE-ENTRETIEN", text: "Guide d'entretien" },
    { value: "HOW-DO-IT", text: "How we do it" },
  ];
  listeSoustType = [
    { value: "0", text: "type 1", ecBlog_Code: "GUIDE-ENTRETIEN" },
    { value: "1", text: "type 2", ecBlog_Code: "GUIDE-ENTRETIEN" },
    { value: "2", text: "type 3", ecBlog_Code: "HOW-DO-IT" },
    { value: "3", text: "type 4", ecBlog_Code: "HOW-DO-IT" },
  ];
  listeSoustTypeFiltred = [];
  step = 0;
  @ViewChild("listeBlogueComponen") listeBlogueComponen: ListeComponent;
  @ViewChild("listeSousTypeComponen") listeSousTypeComponen: ListeComponent;
  listeBlogues = [];
  columns = {
    TableRD: [
      {
        TableRE_Code: "",
        TableRD_Champs: "blogue_Titre",
        Lg_Code: "",
        TableRD_Des: "Titre",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "ecBlogD_Date",
        Lg_Code: "",
        TableRD_Des: "Date",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: "dd-MM-yyyy",
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "ecBlogD_CodeText",
        Lg_Code: "",
        TableRD_Des: "Type blogue",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "ecBlogD_GroupeText",
        Lg_Code: "",
        TableRD_Des: "Sous type blogue",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
    ],
  };
  columnsSousType = {
    TableRD: [
      {
        TableRE_Code: "",
        TableRD_Champs: "fr",
        Lg_Code: "",
        TableRD_Des: "Titre",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "en",
        Lg_Code: "",
        TableRD_Des: "Titre",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
    ],
  };
  mode: string;
  listeAllImages = [];
  listeImagesSelectedBlogue = [];
  selectedImage;
  mainImage;
  sousTypeFr: string;
  sousTypeEn: string;
  compte: number = 0;
  ngOnInit() {
    this.mainImage = { File_Content: "assets/icon.png" };
    this.generaleService.disabled = false;
    this.editorConfig.height = "50px";
    this.editorConfig2.height = "150px";
    //ne pas supprimer
    this.blogue = { ecBlog_Code: "GUIDE-ENTRETIEN" };
    this.getDsBlogues();
    this.getLg();
    this.getListeImage();
    // this.getSousType()
  }
  showListeSousType(frmSousType) {
    this.dialog.open(frmSousType);
    setTimeout(() => {
      this.setDataSourceListeSousTypeComponen();
    }, 100);
  }
  setDataSourceListeSousTypeComponen() {
    if (this.listeSousTypeComponen)
      this.listeSousTypeComponen.setDataSource(this.getListeSousType());
  }
  getListeSousType(): any[] {
    var ecBlog_Code = this.blogue.ecBlog_Code ? this.blogue.ecBlog_Code : "-1";
    var listeLanges = this.listeLanges.filter((lg) => {
      return lg.Lg_Code.indexOf(ecBlog_Code) > -1;
    });
    var distincteCode = this.generaleService.distinct(listeLanges, "Lg_Code");
    var dataSourceTableGideEntretien = [];
    distincteCode.forEach((code) => {
      var fr, en;
      fr = listeLanges.find((lg) => {
        return lg.Lg_Code == code && lg.Lg_Langue == 1;
      });
      en = listeLanges.find((lg) => {
        return lg.Lg_Code == code && lg.Lg_Langue == 0;
      });
      dataSourceTableGideEntretien.push({
        fr: fr ? fr.Lg_Libelle : "",
        en: en ? en.Lg_Libelle : "",
        code,
        Lg_IdFr: fr ? fr.Lg_Id : "",
        Lg_IdEn: en ? en.Lg_Id : "",
      });
    });
    return dataSourceTableGideEntretien;
  }
  ajouterSousType() {
    if (
      this.generaleService.isNotEmpty(this.sousTypeFr) &&
      this.generaleService.isNotEmpty(this.sousTypeEn)
    ) {
      this.compte = 2;
      var code = new Date().getTime();
      this.enregistrerLanguage(
        this.blogue.ecBlog_Code + code,
        0,
        this.sousTypeEn
      );
      this.enregistrerLanguage(
        this.blogue.ecBlog_Code + code,
        1,
        this.sousTypeFr
      );
    } else
      this.generaleService.dialogSuccess(
        "Veuillez remplir tout les champs",
        false
      );
  }
  supprimerSousType() {
    if (this.listeSousTypeComponen.row) {
      var deleteFn = this.generaleService.supprimer(
        this.listeSousTypeComponen.row.Lg_IdFr,
        "lg"
      );
      if (deleteFn != null) {
        this.generaleService.disabled = true;
        deleteFn.subscribe((data) => {
          this.generaleService
            .supprimerSanMsgConfirm(
              this.listeSousTypeComponen.row.Lg_IdEn,
              "lg"
            )
            .subscribe((d) => {
              this.getLg();
            });
        });
      }
    } else
      this.generaleService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
  }
  getListeImage() {
    this.listeAllImages = [];
    this.generaleService
      .rechercheTable(this.generaleService.url + "avtFilesType&param=BLOGUES")
      .subscribe((img) => {
        this.listeAllImages = img;
        this.getImageContent();
      });
  }
  getImageContent() {
    var compte = this.listeAllImages.length;
    for (let i = 0; i < this.listeAllImages.length; i++) {
      this.generaleService
        .rechercheTable(
          this.generaleService.urlFiles +
          "&val=" +
          this.listeAllImages[i].File_Id
        )
        .subscribe((file) => {
          this.listeAllImages[i].File_Content = file.Files[0].File_Content;
          compte--;
          if (compte == 0) this.generaleService.disabled = false;
        });
    }
  }
  addImageDetailBlogue(File_Content, ecBlogD_Code) {
    var lastID = this.listeImagesSelectedBlogue.length + 1;
    this.ajouterImage(File_Content, ecBlogD_Code + "-" + lastID);
  }
  onChangeImagefile(fileInput) {
    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf("image") == 0) {
      reader.onload = (e) => {
        if (this.mode == "ajouter") {
          this.generaleService.disabled = true;
          this.addImageDetailBlogue(
            reader.result.toString(),
            this.listeBlogueComponen.row.ecBlogD_Code
          );
        } else if (this.mode == "modifier") {
          this.generaleService.disabled = true;
          this.modifierImage(
            reader.result.toString(),
            this.selectedImage.File_Id.toString()
          );
        } else if (this.mode == "ajouterProncipale") {
          this.updateMainImage(reader.result.toString());
          //this.mainImage.File_Content = reader.result.toString();
        }
      };
      reader.readAsDataURL(current_file);
    } else
      this.generaleService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
  }
  updateMainImage(File_Content) {
    if (this.blogue.ecBlog_Code) {
      var img = this.listeAllImages.find((img) => {
        return img.File_Key == this.blogue.ecBlog_Code;
      });
      if (img) {
        this.modifierImage(File_Content, img.File_Id);
      } else {
        this.ajouterImage(File_Content, this.blogue.ecBlog_Code);
      }
    }
  }
  modifierImage(File_Content, File_Id) {
    this.generaleService
      .rechercheTable(this.generaleService.urlFiles + "&val=" + File_Id)
      .subscribe((data) => {
        data.Files[0].File_Content = File_Content;
        this.generaleService.enregisterTable(data).subscribe((data) => {
          this.generaleService.disabled = false;
          this.generaleService.dialogSuccess("Enregistrer", true);
        });
      });
  }
  ajouterImage(File_Content, ecBlogD_Code) {
    this.generaleService.disabled = true;
    this.addFiles(
      File_Content,
      "",
      ecBlogD_Code,
      "BLOGUES",
      "",
      "",
      this.blogue.ecBlog_Code,
      ""
    );
  }
  addFiles(
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    var doc = this.generaleService.dsFile;
    doc.files[0].File_Parent = File_Parent;
    doc.files[0].File_Content = File_Content;
    doc.files[0].File_Text = File_Text;
    doc.files[0].File_Key = File_Key;
    doc.files[0].File_Type = File_Type;
    doc.files[0].File_Groupe = File_Groupe;
    doc.files[0].File_Lien = File_Lien;

    this.generaleService.enregisterTable(doc).subscribe(() => {
      this.generaleService.dialogSuccess("Document enregisté", true);
      this.generaleService.disabled = false;
      this.getListeImage();
    });
  }
  openFrmImage(mode, image?) {
    if (mode == "ajouterProncipale") {
      document.getElementById("input_file").click();
      this.mode = mode;
    } else {
      if (this.listeBlogueComponen.row) {
        if (image) this.selectedImage = image;
        this.mode = mode;
        document.getElementById("input_file").click();
      } else
        this.generaleService.dialogSuccess(
          "Veuillez sélectionner une ligne",
          false
        );
    }
  }
  getListeBlogue() {
    this.generaleService
      .rechercheTable("recherche/tbdata?tablere=ecBlogd")
      .subscribe((data) => {
        this.listeBlogues = data;
        this.genererListeBlogue();
      });
  }
  genererListeBlogue() {
    this.listeBlogues.forEach((blogue) => {
      var blogue_TitreFr = this.listeLanges.find((lg) => {
        return (
          lg.Lg_Code == blogue.ecBlogD_Code && lg.Lg_Langue.toString() == "0"
        );
      });
      if (blogue_TitreFr) blogue["blogue_Titre"] = blogue_TitreFr.Lg_Libelle;
      else blogue["blogue_Titre"] = "";
      var typeBlogue = this.listeType.find((type) => {
        return type.value == blogue.ecBlog_Code;
      });
      if (typeBlogue) blogue["ecBlogD_CodeText"] = typeBlogue.text;

      var soustypeBlogue = this.listeSoustType.find((type) => {
        return type.value == blogue.ecBlogD_Groupe;
      });
      if (soustypeBlogue) blogue["ecBlogD_GroupeText"] = soustypeBlogue.text;
    });
    setTimeout(() => {
      this.listeBlogueComponen.setDataSource(
        this.listeBlogues.filter((blogue) => {
          return blogue.ecBlog_Code == this.blogue.ecBlog_Code;
        })
      );
      this.generaleService.disabled = false;
    }, 100);
  }
  setStep(index: number) {
    this.step = index;
  }
  ajouter() {
    if (
      this.blogue.ecBlog_Code &&
      this.blogue.ecBlogD_Groupe &&
      this.blogue_TitreFr
    ) {
      this.generaleService.disabled = true;
      this.blogue.ecBlogD_Code = new Date().getTime().toString();
      this.blogue.ecBlogD_Date = new Date();
      this.generaleService.enregisterTable(this.dsBlogues).subscribe((data) => {
        this.compte = 14;
        //this.ajouterImage(this.mainImage.File_Content,this.blogue.ecBlogD_Code)
        this.generaleService.dialogSuccess("Enregistrer", true);
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code,
          0,
          this.blogue_TitreFr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code,
          1,
          this.blogue_TitreEn
        );

        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-1",
          0,
          this.blogue_P1Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-1",
          1,
          this.blogue_P1En
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-2",
          0,
          this.blogue_P2Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-2",
          1,
          this.blogue_P2En
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-3",
          0,
          this.blogue_P3Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-3",
          1,
          this.blogue_P3En
        );

        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-4",
          0,
          this.blogue_T1Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-4",
          1,
          this.blogue_T1En
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-5",
          0,
          this.blogue_T2Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-5",
          1,
          this.blogue_T2En
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-6",
          0,
          this.blogue_T3Fr
        );
        this.enregistrerLanguage(
          this.blogue.ecBlogD_Code + "-6",
          1,
          this.blogue_T3En
        );
      });
    } else
      this.generaleService.dialogSuccess(
        "Veuillez remplir tous les champs",
        false
      );
  }
  modifier() {
    if (this.listeBlogueComponen.row) {
      this.generaleService.disabled = true;
      this.compte = 16;
      //modification image principal
      // this.generaleService.rechercheTable("ds/formdata?code=avtFiles&val="+this.mainImage.File_Id).subscribe(data =>
      // {
      //   data.Files[0].File_Content = this.mainImage.File_Content;
      //   this.generaleService.enregisterTable(data).subscribe(d =>
      //   {
      //     this.compte--;
      //     if(this.compte == 0)
      //       this.getLg();
      //     this.generaleService.dialogSuccess("Enregistrer",true)
      //   },()=>{this.compte--;this.generaleService.dialogSuccess("Non enregistrer",false)})
      // },()=>{this.compte--;this.generaleService.dialogSuccess("Non enregistrer",false)})

      this.generaleService
        .rechercheTable(
          "ds/formdata?code=ecBlogd&val=" +
          this.listeBlogueComponen.row.ecBlogD_Code
        )
        .subscribe(
          (data) => {
            data.ecBlogD[0].ecBlog_Code = this.blogue.ecBlog_Code;
            data.ecBlogD[0].ecBlogD_Groupe = this.blogue.ecBlogD_Groupe;
            this.generaleService.enregisterTable(data).subscribe(
              (d) => {
                this.compte--;
                if (this.compte == 0) this.getLg();
                this.generaleService.dialogSuccess("Enregistrer", true);
              },
              () => {
                this.compte--;
                this.generaleService.dialogSuccess("Non enregistrer", false);
              }
            );
          },
          () => {
            this.compte--;
            this.generaleService.dialogSuccess("Non enregistrer", false);
          }
        );
      this.modifierLanguage("", this.blogue_TitreFr, this.blogue_TitreEn);
      this.modifierLanguage("-1", this.blogue_P1Fr, this.blogue_P1En);
      this.modifierLanguage("-2", this.blogue_P2Fr, this.blogue_P2En);
      this.modifierLanguage("-3", this.blogue_P3Fr, this.blogue_P3En);

      this.modifierLanguage("-4", this.blogue_T1Fr, this.blogue_T1En);
      this.modifierLanguage("-5", this.blogue_T2Fr, this.blogue_T2En);
      this.modifierLanguage("-6", this.blogue_T3Fr, this.blogue_T3En);
    } else
      this.generaleService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
  }
  modifier_Language(Lg_Id, Lg_Libelle) {
    this.generaleService
      .rechercheTable("ds/formdata?code=Lg&val=" + Lg_Id)
      .subscribe(
        (data) => {
          data.Lg[0].Lg_Libelle = Lg_Libelle;
          data.Lg[0].Lg_Source = "WEB";
          this.generaleService.enregisterTable(data).subscribe(
            () => {
              this.compte--;
              if (this.compte == 0) this.getLg();
              this.generaleService.dialogSuccess("Enregistrer", true);
            },
            () => {
              this.compte--;
              this.generaleService.dialogSuccess("Non enregistrer", false);
            }
          );
        },
        () => {
          this.compte--;
          this.generaleService.dialogSuccess("Non enregistrer", false);
        }
      );
  }
  modifierLanguage(compte: string, Lg_LibelleFr, Lg_LibelleEn) {
    var blogueFr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == this.listeBlogueComponen.row.ecBlogD_Code + compte &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogueFr) this.modifier_Language(blogueFr.Lg_Id, Lg_LibelleFr);
    else this.compte--;
    var blogueEn = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == this.listeBlogueComponen.row.ecBlogD_Code + compte &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogueEn) this.modifier_Language(blogueEn.Lg_Id, Lg_LibelleEn);
    else this.compte--;
  }

  enregistrerLanguage(Lg_Code, Lg_Langue, Lg_Libelle) {
    this.generaleService.dsLanguage.Lg[0].Lg_Code = Lg_Code;
    this.generaleService.dsLanguage.Lg[0].Lg_Langue = Lg_Langue;
    this.generaleService.dsLanguage.Lg[0].Lg_Libelle = Lg_Libelle;
    this.generaleService.dsLanguage.Lg[0].Lg_Source = "WEB";
    this.generaleService
      .enregisterTable(this.generaleService.dsLanguage)
      .subscribe(
        (data) => {
          this.generaleService.dialogSuccess("Enregistrer", true);
          this.generaleService.disabled = false;
          this.compte--;
          if (this.compte == 0) this.getLg();
        },
        () => {
          this.generaleService.dialogSuccess("Non enregistrer", false);
          this.generaleService.disabled = false;
          this.compte--;
        }
      );
  }
  getDsBlogues() {
    this.generaleService
      .rechercheTable("ds/formdata?code=ecBlogd")
      .subscribe((data) => {
        this.dsBlogues = data;
        this.blogue = this.dsBlogues.ecBlogD[0];
        this.blogue.ecBlog_Code = "GUIDE-ENTRETIEN";
      });
  }
  supprimer() {
    var deleteFn = this.generaleService.supprimer(
      this.listeBlogueComponen.row.ecBlogD_Code,
      "ecBlogD"
    );
    if (deleteFn != null) {
      this.generaleService.disabled = true;
      deleteFn.subscribe((data) => {
        var listeImagesSelectedBlogue = this.listeAllImages.filter((img) => {
          return (
            img.File_Key.indexOf(this.listeBlogueComponen.row.ecBlogD_Code) > -1
          );
        });
        var listeLanges = this.listeLanges.filter((lg) => {
          return (
            lg.Lg_Code.indexOf(this.listeBlogueComponen.row.ecBlogD_Code) > -1
          );
        });
        this.compte =
          listeLanges.length + this.listeImagesSelectedBlogue.length;
        listeLanges.forEach((lg) => {
          this.generaleService
            .supprimerSanMsgConfirm(lg.Lg_Id, "lg")
            .subscribe((d) => {
              this.compte--;
              if (this.compte == 0) {
                this.generaleService.disabled = false;
                this.generaleService.dialogSuccess("Supprimer", true);
              }
            });
        });

        listeImagesSelectedBlogue.forEach((img) => {
          this.generaleService
            .supprimerSanMsgConfirm(img.File_Id, "avtFiles")
            .subscribe((d) => {
              this.compte--;
              if (this.compte == 0) {
                this.generaleService.disabled = false;
                this.generaleService.dialogSuccess("Supprimer", true);
              }
            });
        });
        if (this.compte == 0) {
          this.generaleService.disabled = false;
          this.generaleService.dialogSuccess("Supprimer", true);
        }
      });
    }
  }
  getLg() {
    this.generaleService
      .rechercheTable("recherche/tbdata?tablere=lgweb")
      .subscribe((data) => {
        this.listeLanges = data;
        this.getListeBlogue();
        this.setDataSourceListeSousTypeComponen();
        this.ecBlogD_CodeChange();
      });
  }
  ecBlogD_CodeChange() {
    this.listeSoustTypeFiltred = this.getListeSousType();
    var img = this.listeAllImages.find((img) => {
      return img.File_Key == this.blogue.ecBlog_Code;
    });
    if (img) this.mainImage = img;
    this.listeBlogueComponen.setDataSource(
      this.listeBlogues.filter((blogue) => {
        return blogue.ecBlog_Code == this.blogue.ecBlog_Code;
      })
    );
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case "selectRow": {
        this.showRow(event);
        break;
      }
    }
  }
  showRow(event) {
    var blogue_TitreFr,
      blogue_TitreEn,
      blogue_P1Fr,
      blogue_P1En,
      blogue_P2Fr,
      blogue_P2En,
      blogue_P3Fr,
      blogue_P3En,
      blogue_T1Fr,
      blogue_T1En,
      blogue_T2Fr,
      blogue_T2En,
      blogue_T3Fr,
      blogue_T3En;
    blogue_TitreFr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code && lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_TitreFr) this.blogue_TitreFr = blogue_TitreFr.Lg_Libelle;
    blogue_TitreEn = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code && lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_TitreEn) this.blogue_TitreEn = blogue_TitreEn.Lg_Libelle;
    blogue_P1Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-1" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_P1Fr) this.blogue_P1Fr = blogue_P1Fr.Lg_Libelle;
    blogue_P1En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-1" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_P1En) this.blogue_P1En = blogue_P1En.Lg_Libelle;
    blogue_P2Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-2" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_P2Fr) this.blogue_P2Fr = blogue_P2Fr.Lg_Libelle;
    blogue_P2En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-2" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_P2En) this.blogue_P2En = blogue_P2En.Lg_Libelle;

    blogue_P3Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-3" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_P3Fr) this.blogue_P3Fr = blogue_P3Fr.Lg_Libelle;
    blogue_P3En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-3" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_P3En) this.blogue_P3En = blogue_P3En.Lg_Libelle;

    blogue_T1Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-4" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_T1Fr) this.blogue_T1Fr = blogue_T1Fr.Lg_Libelle;
    blogue_T1En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-4" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_T1En) this.blogue_T1En = blogue_T1En.Lg_Libelle;
    blogue_T2Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-5" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_T2Fr) this.blogue_T2Fr = blogue_T2Fr.Lg_Libelle;
    blogue_T2En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-5" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_T2En) this.blogue_T2En = blogue_T2En.Lg_Libelle;

    blogue_T3Fr = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-6" &&
        lg.Lg_Langue.toString() == "0"
      );
    });
    if (blogue_T3Fr) this.blogue_T3Fr = blogue_T3Fr.Lg_Libelle;
    blogue_T3En = this.listeLanges.find((lg) => {
      return (
        lg.Lg_Code == event.row.ecBlogD_Code + "-6" &&
        lg.Lg_Langue.toString() == "1"
      );
    });
    if (blogue_T3En) this.blogue_T3En = blogue_T3En.Lg_Libelle;

    this.blogue.ecBlog_Code = event.row.ecBlog_Code;
    this.ecBlogD_CodeChange();
    this.blogue.ecBlogD_Groupe = event.row.ecBlogD_Groupe;
    this.listeImagesSelectedBlogue = this.listeAllImages.filter((img) => {
      return img.File_Key.indexOf(event.row.ecBlogD_Code) > -1;
    });
    // var mainImage = this.listeAllImages.filter(img =>{return img.File_Key== event.row.ecBlogD_Code})
    // if(mainImage.length>0)
    // this.mainImage = mainImage[0];
  }
}
